"use strict";

exports.implementation = class NavigatorCookiesImpl {
  get cookieEnabled() {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/navigator/NavigatorCookies-impl.js
// module id = RbtW
// module chunks = 0